//#region imports
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

// bootstrap
import Carousel from 'react-bootstrap/Carousel';
import { Row, Col, Image, Badge, Navbar, Nav } from 'react-bootstrap';

// logos
import ncbi from "_assets/images/home/sponsers/NCBI.png";
import JerseyAirport from "_assets/images/logo/JER-logo.png";
import aerlingusAirport from "_assets/images/logo/AER-logo.png";
import corkAirport from "_assets/images/logo/CORK-logo.png";
import dublinAirport from "_assets/images/logo/DUB-logo.png";
import edinAirport from "_assets/images/logo/EDI-logo.png";
import belfastAirport from "_assets/images/logo/BFS-logo.png";
import invernessAirport from "_assets/images/logo/INV-logo.png";
import southamptonAirport from "_assets/images/logo/SOU-logo.png";
import sgsAirport from "_assets/images/logo/SGS-logo.png";
import sydLogo from "_assets/images/logo/SYD-logo.png";
import glaLogo from "_assets/images/logo/GLA-logo.png";
import sgsLogo from "_assets/images/logo/SGS-logo.png";
import brsLogo from "_assets/images/profile/BRS-CIRCLE.png";
import donegalLogo from "_assets/images/account/donegal-airport.jpeg";
import healthcareAbroad from '_assets/images/account/healthcare-abroad.png';

// styling
import './style.css';

//#endregion


const PartnerCarousel = (props) => {

    //#region state - screen sizes
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1200 });
    const isDesktop = useMediaQuery({ minWidth: 1025 });

    // partners data - img, name, description
    const partnerData = [
        {
            logo: dublinAirport,
            name: "Dublin Airport",
            description: "Dublin Airport, Ireland"
        },
        {
            logo: corkAirport,
            name: "Cork Airport",
            description: "Cork Airport, Ireland"
        },
        {
            logo: belfastAirport,
            name: "Belfast Airport",
            description: "Belfast Airport, Northern Ireland"
        },
        {
            logo: aerlingusAirport,
            name: "Aerlingus",
            description: "Aerlingus, Ireland"
        },
        {
            logo: donegalLogo,
            name: "Donegal Airport",
            description: "Donegal Airport, Ireland"
        },
        {
            logo: JerseyAirport,
            name: "Jersey Airport",
            description: "Jersey Airport, United Kingdom"
        },
        {
            logo: edinAirport,
            name: "Edinboruough Airport",
            description: "Edinboruough Airport, United Kingdom"
        },
        {
            logo: invernessAirport,
            name: "Inverness Airport",
            description: "Inverness Airport, United Kingdom"
        },
        {
            logo: southamptonAirport,
            name: "Southampton Airport",
            description: "Southampton Airport, United Kingdom"
        },
        {
            logo: brsLogo,
            name: "Bristol Airport",
            description: "Bristol Airport, United Kingdom"
        },
        {
            logo: glaLogo,
            name: "Glasgow Airport",
            description: "Glasgow Airport, United Kingdom"
        },
        {
            logo: sydLogo,
            name: "Sydney Airport",
            description: "Sydney Airport, Australia"
        },
        {
            logo: sgsLogo,
            name: "King Abdulaziz International Airport",
            description: "King Abdulaziz International Airport, Saudia Arabia"
        },
        {
            logo: sgsLogo,
            name: "King Khaled International Airport",
            description: "King Khaled International Airport, Saudia Arabia"
        },
        {
            logo: ncbi,
            name: "NCBI",
            description: "National Council for the Blind Ireland"
        },
        {
            logo: sgsAirport,
            name: "SGS Operations",
            description: "SGS Operations, Saudi Arabia"
        },
        {
            logo: healthcareAbroad,
            name: "Healthcare Abroad",
            description: "Dublin, Ireland"
        },
    ];

    // splitting the partners data into groups for the carousel slide - 4 partners per slide on desktop
    const chunkPartnerData = [];
    let splitInto = 8;              // default 4 per slide

    if (isMobile) {
        splitInto = 2;              // 1 per slide
    }
    else if (isTablet) {
        splitInto = 4;              // 2 per slide
    }

    for (let i = 0; i < partnerData.length; i += splitInto) {
        let partners = partnerData.slice(i, i + splitInto);
        chunkPartnerData.push([partners.slice(0, partners.length / 2), partners.slice(partners.length / 2)]);
    }
    //#endregion


    // partner card
    const PartnerCard = (props) => {

        return (
            <div
                className="d-flex shadow-sm partner-card"
                style={{
                    border: '1px solid #ccc',
                    height: 125,
                    borderRadius: 10,
                    overflow: 'hidden',
                }}
            >
                {/* Left image */}
                <div
                    className="d-flex align-items-center justify-content-center partner-img-wrapper"
                    style={{
                        width: '50%',
                        backgroundColor: '#f8f9fa',
                        padding: '10px',
                    }}
                >
                    <img
                        src={props.logo}
                        alt={props.name}
                        style={{
                            width: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                        }}
                    />
                </div>

                {/* Right text */}
                <div
                    className="d-flex align-items-center"
                    style={{
                        width: '50%',
                        padding: '10px',
                        overflowWrap: 'break-word',
                    }}
                >
                    <p
                        style={{
                            fontSize: 16,
                            opacity: 0.7,
                            lineHeight: '1.4',
                            margin: 0,
                        }}
                    >
                        {props.description}
                    </p>
                </div>
            </div>

        )
    }

    return (
        <Carousel className='mt-4 h-100' variant="dark" interval={2000} controls={false} indicators={false} pause="false">
            {/* loop over each group */}
            {
                chunkPartnerData.map((partnerGroup, index) => (
                    <Carousel.Item key={index}>
                        {partnerGroup.map((rows, index) => (
                            <Row key={index} className="justify-content-center">
                                {
                                    rows.map((partner, index) => {
                                        return (<Col key={index} xs={12} sm={12} md={6} lg={6} xl={3} className="d-flex justify-content-center mb-4">
                                            <PartnerCard
                                                logo={partner.logo}
                                                name={partner.name}
                                                description={partner.description}
                                            />
                                        </Col>
                                        )
                                    })
                                }
                            </Row>
                        ))}
                    </Carousel.Item>
                ))
            }
        </Carousel>
    );
};

export default PartnerCarousel;
